"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionStorage = void 0;
// eslint-disable-next-line 
var memoryCache = new Map();
var SessionStorage = /** @class */ (function () {
    function SessionStorage(config) {
        this.config = config;
    }
    SessionStorage.prototype.setItem = function (key, value) {
        if (!(value == null || value.length === 0)) {
            window.sessionStorage.setItem(key, value);
            return window.sessionStorage.getItem(key);
        }
        return null;
    };
    SessionStorage.prototype.getItem = function (key) {
        return window.sessionStorage.getItem(key);
    };
    SessionStorage.prototype.removeItem = function (key) {
        if (this.getItem(key)) {
            window.sessionStorage.removeItem(key);
            return true;
        }
        else {
            return false;
        }
    };
    SessionStorage.prototype.clear = function () {
        memoryCache = new Map();
        return {};
    };
    return SessionStorage;
}());
exports.SessionStorage = SessionStorage;
//# sourceMappingURL=session.storage.js.map